import { AfterViewChecked, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { SharedService } from 'src/app/_shared/shared.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewChecked {

  constructor(public shared: SharedService, private translate: TranslateService, private titleService: Title) {
    shared.setTranslate(this.translate);

    if (environment.production) {
      console.log = function () { };
    } else {
      console.log("THIS IS DEV");
    }
  }

  ngAfterViewChecked(): void {
    this.shared.isMobileConst = this.shared.isMobile();
  }
}
